import { ChevronDown } from "lucide-react";
import { AspectRatioPicker } from "@/components/flowly/AspectRatioPicker/AspectRatioPicker";
import { AspectRatioIcon } from "@/components/flowly/AspectRatioPicker/AspectRatioIcon";
import { ASPECT_RATIOS } from "@/components/flowly/AspectRatioPicker/constants";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { BarControl } from "./BarControl";
import type { AspectRatioControlProps } from "./types";

export function AspectRatioControl({
  aspectRatio,
  onAspectRatioChange,
  availableRatios,
}: AspectRatioControlProps) {
  const matchedRatio = ASPECT_RATIOS.find((r) => r.id === aspectRatio);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <BarControl>
          {matchedRatio && (
            <AspectRatioIcon
              type={matchedRatio.icon}
              className="text-white"
            />
          )}
          <span className="text-white font-bold text-xs">
            {matchedRatio ? matchedRatio.label : aspectRatio}
          </span>
          <ChevronDown className="w-3 h-3 text-white/60" />
        </BarControl>
      </PopoverTrigger>
      <PopoverContent align="center" className="w-72 p-4 z-[60]">
        <AspectRatioPicker
          aspectRatio={aspectRatio}
          onAspectRatioChange={onAspectRatioChange}
          availableRatios={availableRatios}
        />
      </PopoverContent>
    </Popover>
  );
}
